import { configureStore } from '@reduxjs/toolkit';
import { profileSlice } from '../../../lib/client/features/dataCloud/profileSlice';
import { journeySlice } from '../../../lib/client/features/journeyBuilder/journeySlice';
import { dataSelectorSlice } from './features/dataSelector/dataSelectorSlice';

export const store = configureStore({
    reducer: {
        journey: journeySlice.reducer,
        dataSelector: dataSelectorSlice.reducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
